<script>
import {
  pageMonCompteMesCommandesDetailsProduitsProps,
  usePageMonCompteMesCommandesDetailsProduits
} from "./mixin";
import StateOverlay from "@/components/molecules/state-overlay";
import Card from "@/components/molecules/card";
import Button from "@/components/atoms/button";
import Titre from "@/components/atoms/titre";
import CoursesExpressProductList from "@/containers/mon-compte/courses-express-product-list";
import CommandeNommer from "@/containers/commande-nommer";
import Popin from "@/components/molecules/popin";
import ButtonIcon from "@/components/molecules/button-icon";

export default {
  name: "CommandesDetails",
  components: {
    Card,
    Button,
    Titre,
    StateOverlay,
    CoursesExpressProductList,
    CommandeNommer,
    Popin,
    ButtonIcon
  },
  props: {
    ...pageMonCompteMesCommandesDetailsProduitsProps()
  },
  setup(props) {
    const {
      isLoading,
      titre,
      nomCommande,
      addToCartCommande,
      addToCartProduits,
      nameChanged,
      mounted
    } = usePageMonCompteMesCommandesDetailsProduits(props);

    onMounted(mounted);

    return {
      isLoading,
      titre,
      nomCommande,
      addToCartCommande,
      addToCartProduits,
      nameChanged
    };
  }
};
</script>

<template>
  <StateOverlay
    overlay
    :is-loading="isLoading"
  >
    <div v-if="commande">
      <Popin
        ref="renommer"
        aria-label="Nommer la commande"
      >
        <CommandeNommer
          :name="nomCommande"
          :commande="commande"
          @validate="nameChanged"
        />
      </Popin>
      <ButtonIcon
        link
        no-underline
        icon-name="arrow-left"
        icon-color="text"
        variant="text"
        icon-size="sm"
        to="/mon-compte/mes-commandes"
      >
        Retour
      </ButtonIcon>
      <Titre
        tag="h1"
        variant="primary"
        size="sm"
        class="u-mb-md u-mt-md"
      >
        Sélectionner des produits de ma commande
      </Titre>
      <Card
        elevation="md"
        radius="md"
        class="u-p-md u-mb-md"
      >
        <Titre
          tag="h2"
          size="md"
          class="u-mb-xs"
        >
          {{ commande.attributes.code }}
        </Titre>
        <p
          v-if="nomCommande"
          class="u-font-17"
        >
          {{ nomCommande }}
        </p>
        <Button
          link
          variant="text-light"
          class="u-mb-md"
          @click="$refs.renommer.show()"
        >
          <template v-if="nomCommande">
            Renommer
          </template>
          <template v-else>
            Nommer
          </template>
        </Button>

        <div class="u-flex u-flex-align-center">
          <p class="u-font-17">
            <strong class="u-font-500">{{ commande.attributes.nb_produits }} {{ pluralize(commande.attributes.nb_produits, 'produit') }}</strong>
          </p>
          <Button
            variant="secondary"
            radius="full"
            size="md"
            class="u-ml-md"
            :disabled="commande.attributes.nb_produits === 0"
            @click="addToCartCommande"
          >
            Ajouter tout au panier
          </Button>
        </div>
      </Card>

      <CoursesExpressProductList
        :can-delete="false"
        :cart-context="trackingCodes.LABELGA.AnciennesCommandes"
        class="u-mt-md"
        :items="commande.attributes.produits.data"
        :sections="meta.sections.valeurs"
        :indisponibles="meta.items_indisponibles"
        @addToCart="addToCartProduits"
      />
    </div>
  </StateOverlay>
</template>

<style lang="scss" scoped>
</style>
